<template>
  <div class="pa-3">
    <div class="text-xs-right">
      <v-btn icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <div>
      <v-layout row wrap>
        <v-flex xs6>
          <v-card class="pa-2 mr-1">
            <div class="primary--text" style="font-weight: bold">Average Check-in time</div>
            <div>{{ avgCheckIn }}</div>
          </v-card>
        </v-flex>
        <v-flex xs6>
          <v-card class="pa-2 ml-1">
            <div class="primary--text" style="font-weight: bold">Average Check-out time</div>
            <div>{{ avgCheckOut }}</div>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
    <div class="primary--text mb-2" style="font-size: 18px; font-weight: 600">
      Check-in & Check-out performance
    </div>
    <DateFilter
      v-model="selectedDate"
      :default-filter="'last_month'"
      @changeDate="handleGetAdminCheckInCheckOutLog"
    ></DateFilter>
    <div class="mt-3">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="logData"
        class="elevation-1"
        :pagination.sync="pagination"
      >
        <template #items="props">
          <tr>
            <td>
              {{ props.item.check_in_timestamp | DateFormat('DD/MM/YYYY') }}
            </td>
            <td>
              <template v-if="props.item.check_in_timestamp">
                {{ props.item.check_in_timestamp | DateFormat('HH:mm') }}
              </template>
              <template v-else>-</template>
            </td>
            <td>
              <template v-if="props.item.check_out_timestamp">
                {{ props.item.check_out_timestamp | DateFormat('HH:mm') }}
              </template>
              <template v-else>-</template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'

import ticketApi from '@/api/ticket'
import dayjs from 'dayjs'

export default {
  components: {
    DateFilter
  },
  props: {
    selectedAdmin: {
      default: '',
      type: String
    }
  },

  data() {
    return {
      avgCheckIn: '-',
      avgCheckOut: '-',
      logData: [],
      pagination: { rowsPerPage: 10, sortBy: '' },
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Check-in time', value: 'check_in_timestamp' },
        { text: 'Check-out time', value: 'check_out_timestamp' }
      ],
      loading: false,
      selectedDate: {
        start: dayjs().subtract(1, 'months').format('YYYY-MM-DD 00:00'),
        end: dayjs().format('YYYY-MM-DD 23:59')
      },
      adminId: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.selectedAdmin) {
      this.adminId = this.selectedAdmin
      this.handleGetAdminCheckInCheckOutLog()
    }
  },
  methods: {
    handleCalculateAverageTime() {
      const vm = this
      try {
        const checkInTimes = vm.logData.map((el) => {
          if (el.check_in_timestamp) {
            return dayjs(el.check_in_timestamp).format('HH:mm:ss')
          } else return null
        })
        const checkOutTimes = vm.logData.map((el) => {
          if (el.check_out_timestamp) {
            return dayjs(el.check_out_timestamp).format('HH:mm:ss')
          } else return null
        })

        if (checkInTimes.length > 0) {
          const tempAvgCheckIn = vm.getAverageTime(checkInTimes)
          vm.avgCheckIn = tempAvgCheckIn ? dayjs(`1/1/1 ${tempAvgCheckIn}`).format('HH:mm') : ''
        }

        if (checkOutTimes.length > 0) {
          const tempAvgCheckOut = vm.getAverageTime(checkOutTimes)
          vm.avgCheckOut = tempAvgCheckOut ? dayjs(`1/1/1 ${tempAvgCheckOut}`).format('HH:mm') : ''
        }
      } catch (error) {
        console.error(error)
        console.error('transform data failed')
      }
    },
    async handleGetAdminCheckInCheckOutLog() {
      const vm = this
      try {
        vm.loading = true
        const response = await vm.getAdminCheckInCheckOut()
        vm.loading = false

        if (response && response.status === 200) {
          const responseData = response.data.data
          vm.logData = responseData
          vm.handleCalculateAverageTime()
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.loading = false
      }
    },
    async getAdminCheckInCheckOut() {
      const vm = this
      try {
        const params = {
          admin_id: vm.adminId,
          page_id: vm.selectedBot.pageid,
          limit: 10,
          offset: 0,
          start_date: vm.selectedDate.start,
          end_date: vm.selectedDate.end
        }

        const response = await ticketApi.getAdminCheckInCheckOut({ params })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    getAverageTime(times) {
      try {
        let result = null
        const tempTimes = times.filter((el) => el)
        const count = tempTimes.length

        let timesInSeconds = []

        for (let i = 0; i < count; i++) {
          const pieces = tempTimes[i].split(':')
          const hrs = Number(pieces[0])
          const mins = Number(pieces[1])
          const secs = Number(pieces[2])

          let totalSecs = hrs * 60 * 60
          totalSecs += mins * 60
          totalSecs += secs
          timesInSeconds[i] = totalSecs
        }

        let total = 0
        for (let j = 0; j < count; j++) {
          if (timesInSeconds[j]) {
            total = total + Number(timesInSeconds[j])
          }
        }

        const avg = Math.round(total / count)
        let avgMins = Math.floor(avg / 60)
        let avgSecs = avg - 60 * avgMins
        let avgHrs = Math.floor(avgMins / 60)

        avgMins = avgMins - 60 * avgHrs
        avgSecs = ('0' + avgSecs).slice(-2)
        avgMins = ('0' + avgMins).slice(-2)

        result = `${avgHrs}:${avgMins}:${avgSecs}`

        return result
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/DialogCheckInCheckOut.vue